(function () {
  'use strict';
  function selectedOption(control) { return control.tagName === 'SELECT' ? control.selectedOptions[0] : control; }
  function prepare(form, original) {
    const section = form.closest('.product-section');
    if (!section) return original;
    const panel = Array.from(section.querySelectorAll('[data-xr-addons]')).find(node => node.dataset.formId === form.getAttribute('id'));
    if (!panel) return original;
    // Complimentary gifts are reconciled once per order after the rack enters the cart.
    const selected = Array.from(panel.querySelectorAll('[data-xr-addon]')).filter(row => row.querySelector('[data-xr-addon-check]').checked && !row.classList.contains('is-free'));
    if (!selected.length || !original.get('id')) return original;
    const data = new FormData();
    for (const [key, value] of original.entries()) {
      if (key === 'id' || key === 'quantity' || key === 'selling_plan') data.append('items[0][' + key + ']', value);
      else if (key.startsWith('properties[')) data.append('items[0][properties]' + key.slice(10), value);
      else data.append(key, value);
    }
    if (!original.has('quantity')) data.append('items[0][quantity]', '1');
    selected.forEach((row, index) => {
      const prefix = 'items[' + (index + 1) + ']';
      data.append(prefix + '[id]', row.querySelector('[data-xr-addon-variant]').value);
      data.append(prefix + '[quantity]', '1');
      if (row.querySelector('[data-xr-addon-preorder]')) data.append(prefix + '[properties][Order type]', 'Preorder');
    });
    return data;
  }
  function refresh(panel, price) {
    if (Number.isFinite(price)) panel.dataset.rackPrice = price;
    let count = 0;
    panel.querySelectorAll('[data-xr-addon]').forEach(row => {
      const checkbox = row.querySelector('[data-xr-addon-check]');
      const option = selectedOption(row.querySelector('[data-xr-addon-variant]'));
      const free = !!row.dataset.giftKind && Number(panel.dataset.rackPrice) >= Number(row.dataset.freeThreshold);
      if (free) { checkbox.checked = true; checkbox.setAttribute('aria-disabled', 'true'); }
      else if (row.classList.contains('is-free')) { checkbox.checked = false; checkbox.removeAttribute('aria-disabled'); }
      row.classList.toggle('is-free', free);
      row.classList.toggle('is-selected', checkbox.checked);
      row.querySelector('[data-xr-addon-original]').hidden = !free;
      row.querySelector('[data-xr-addon-original]').textContent = option.dataset.money;
      row.querySelector('[data-xr-addon-gift-note]').hidden = !free;
      row.querySelector('[data-xr-addon-price]').textContent = free ? 'FREE' : option.dataset.money;
      if (checkbox.checked && !free) count++;
    });
    panel.querySelector('[data-xr-addon-status]').textContent = count ? count + ' optional upgrade(s) selected. Your free gifts are included automatically.' : 'Your free gifts are included automatically. Select any optional upgrades above.';
  }
  function initialize(root) {
    root.querySelectorAll('[data-xr-addons]').forEach(panel => {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      panel.addEventListener('change', () => refresh(panel));
      panel.addEventListener('click', event => {
        const row = event.target.closest('[data-xr-addon]');
        if (row?.classList.contains('is-free') && (event.target.matches('[data-xr-addon-check]') || event.target.closest('label'))) event.preventDefault();
      });
      refresh(panel);
    });
  }
  document.addEventListener('variantChange', event => {
    const variant = event.detail?.variant;
    if (!variant) return;
    const section = event.target.closest?.('.product-section');
    if (!section) return;
    section.querySelectorAll('[data-xr-addons]').forEach(panel => refresh(panel, variant.price));
    section.querySelectorAll('[data-xr-delivery-stamp]').forEach(stamp => { stamp.hidden = variant.price < 200000; });
  }, true);
  window.xrRackCart = {prepare};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('quickview:loaded', () => initialize(document));
})();
